import React from 'react';
import { Route, IndexRoute } from 'react-router';
import axios from 'axios';
import {replace as replaceLodash} from 'lodash';
import { appBasePath } from './constants/staticData';
// Containers
import AuthContainer from './containers/AuthContainer';
import VendorProfileContainer from './containers/VendorProfileContainer';
import JobRequestContainer from './containers/JobRequestContainer';
import UseraccountContainer from './containers/useraccountContainer';
import ManageInfoContainer from './containers/manageInfoContainer';
import DriverEmergenyContainer from './containers/DriverEmergencyContainer';

// Auth Components
import SignIn from './components/Auth/SignIn';
import SignUp from './components/Auth/SignUp';
import VerifyOTP from './components/Auth/VerifyOTP';
import SendOTP from './components/Auth/SendOTP';
import BusinessDetail from './components/Auth/BusinessDetail';
import ForgotPassword from './components/Auth/ForgotPassword';
import VendorProfile from './components/VendorProfile/VendorProfile';
import NonVerified from './components/Auth/NonVerified';
import Overview from './components/Overview/Overview';
import Results from './components/Results/Results';
import Inbox from './components/Inbox/Inbox';
import EmergencyList from './components/emergencyServices/EmergencyList';

import ResetPassword from './components/Auth/ResetPassword';
import Confirmed from './components/Auth/Confirmed';
import ResetEmailConfirmation from './components/Auth/ResetEmailConfirmation';
import EmailVerified from './components/Auth/EmailVerified';
import pageNotFound from './components/pageNotFound/pageNotFound.jsx';
import UserAccounts from './components/UserAccounts/userAccounts.jsx';
import ManageUser from './components/ManageUser/manageUser.jsx';
import MyVehicles from './components/MyVehicles/myVehicles.jsx';
import AddUser from './components/ManageUser/addUser.jsx';
import AddVehicle from './components/MyVehicles/addVehicle.jsx';
import EditUser from './components/ManageUser/editUser.jsx';
import VehiclePersonalInfo from './components/MyVehicles/VehiclePersonalInfo.jsx';
import EditVehicle from './components/MyVehicles/EditVehicle.jsx';
import businessLanding from './components/BusinessLanding/businessLanding.jsx';
import businessContactUs from './components/BusinessLanding/businessContactUs.jsx';
import BusinessSignInAs from './components/BusinessLanding/BusinessSignInAs.jsx';
import BusinessSignUpAs from './components/BusinessLanding/BusinessSignUpAs.jsx';
import Notification from './components/Notification/Notification.jsx';

import JobDetailsView from './components/JobDetailsView/JobDetailsView';
//Driver components
import DriverEmergencyHome from './components/DriverEmergency/DriverEmergencyHome.jsx';
import DriverEmergencyAceptDecline from './components/DriverEmergency/DriverEmergencyAceptDecline.jsx';
import DriverEmergencyEndJob from './components/DriverEmergency/DriverEmergencyEndJob.jsx';
import { store } from "./index";

// Dashboard Components

export const isLoggedIn = (nextState, replace) => {


  if (localStorage.businessAccessToken) {
    axios.defaults.headers.common['x-access-token'] = localStorage.businessAccessToken;
  }

  if (localStorage.garage_id) {
    axios.defaults.headers.common['garage-id'] = localStorage.garage_id;
  }
  window.scrollTo(0, 0);
  const userId = localStorage.getItem('businessUserId');
  let authData = localStorage.getItem('businessAuthData');
  authData = authData ? JSON.parse(authData) : '';
  if (authData && authData.type === 'customer') {
    // window.location.pathname = '/';
    window.location.pathname = `${appBasePath}/sign-in`;
  } else if (!(userId && authData && authData.phone && authData.phoneVerified)) {
    replace({
      pathname: `${appBasePath}/sign-in`
    });


    let pathName = nextState.location.pathname+nextState.location.search;
   // pathName = pathName.replace('/business/', '');


    store.dispatch({
      type: "REDIRECT_URI",
      payload: replaceLodash(pathName, '/business/', '')
    });

    // window.location.pathname = `${appBasePath}/sign-in`;
  } else if (
    authData &&
    !authData.isEmergencyDriver &&
    !authData.isBusinessRegistered &&
    nextState.location.pathname != `${appBasePath}/business-detail`
  ) {
    replace({
      pathname: `${appBasePath}/business-detail`
    });
  } else if (
    authData &&
    authData.isBusinessRegistered &&
    !authData.isGarageProfileCompleted &&
    nextState.location.pathname != `${appBasePath}/vendor-profile/manage-profile`
  ) {
    replace({
      pathname: `${appBasePath}/vendor-profile/manage-profile`
    });
  } else if (
    authData &&
    authData.isBusinessRegistered &&
    authData.isGarageProfileCompleted &&
    !authData.isGarageServiceSelected &&
    nextState.location.pathname != `${appBasePath}/vendor-profile/manage-services`
  ) {
    replace({
      pathname: `${appBasePath}/vendor-profile/manage-services`
    });
  } else {

    window.axiosInterceptor = axios.interceptors.response.use(
      response => {
        return response;
      },
      function(error) {

        if (error.response.status === 401) {
          localStorage.clear();
          window.location.pathname = '/business/sign-in';
        }
        return Promise.reject(error);
      }
    );
  }
};

export const scrollToTop = () => {
  if (localStorage.businessAccessToken) {
    axios.defaults.headers.common['x-access-token'] = localStorage.businessAccessToken;
  }
  window.scrollTo(0, 0);
};

import Home from './components/Home';
import Dashboard from './components/Dashboard';
import OpenJobs from './components/OpenJobs/OpenJobs';
import WaitingJobs from './components/StatusList/WaitingJobs';
import AppliedJobs from './components/StatusList/AppliedJobs';
import ConfirmedJobs from './components/StatusList/ConfirmedJobs';
import InprogressJobs from './components/StatusList/InprogressJobs';
import CompletedJobs from './components/StatusList/CompletedJobs';
import ProfileCreation from './components/ProfileCreation/ProfileCreation.jsx';
import JobHistory from './components/JobHistory/JobHistory.jsx';
import EmptyState from './components/EmptyState/EmptyState.jsx';
import ManageServices from './components/ManageServices/ManageServices';
import TermsAndConditions from './components/common/TermsAndConditions';
import Onboarding from './components/Onboarding/Onboarding';
import ReviewRating from './components/ReviewRating/ReviewRating';
import Policy from "./components/Policy/Policy";
import Faq from './components/Faq/Faq';
import ContactUs from './components/ContactUs/ContactUs';

export default (
  <Route
    path={process.env.NODE_ENV === 'production' ? '/business' : '/'}
    component={Home}
    onUpdate={() => window.scrollTo(0, 0)}
  >
    <IndexRoute component={AuthContainer(businessLanding)} />
    <Route path="dashboard" onEnter={isLoggedIn} component={AuthContainer(Dashboard)} />
    <Route path="sign-in" onEnter={scrollToTop} component={AuthContainer(SignIn)} />
    <Route path="sign-up" onEnter={scrollToTop} component={AuthContainer(SignUp)} />
    <Route path="business" onEnter={scrollToTop} component={AuthContainer(businessLanding)} />
    <Route path="signin-as" onEnter={scrollToTop} component={AuthContainer(BusinessSignInAs)} />
    <Route path="signup-as" onEnter={scrollToTop} component={AuthContainer(BusinessSignUpAs)} />
    <Route path="contact" onEnter={scrollToTop} component={AuthContainer(businessContactUs)} />
    <Route path="send-otp" onEnter={scrollToTop} component={AuthContainer(SendOTP)} />
    <Route path="send-otp/:id" onEnter={scrollToTop} component={AuthContainer(SendOTP)} />
    <Route path="verify-otp" onEnter={scrollToTop} component={AuthContainer(VerifyOTP)} />
    <Route path="verify-otp/:id" onEnter={scrollToTop} component={AuthContainer(VerifyOTP)} />
    <Route path="business-detail" onEnter={isLoggedIn} component={AuthContainer(BusinessDetail)} />
    <Route path="forgot-password" onEnter={scrollToTop} component={AuthContainer(ForgotPassword)} />
    <Route path="reset-password" onEnter={scrollToTop} component={AuthContainer(ResetPassword)} />
    <Route path="confirmed" onEnter={scrollToTop} component={AuthContainer(Confirmed)} />
    <Route path="reset-email-confirmation" onEnter={scrollToTop} component={AuthContainer(ResetEmailConfirmation)} />
    <Route path="verify" component={AuthContainer(EmailVerified)} />
    <Route path="non-verified" onEnter={isLoggedIn} component={AuthContainer(NonVerified)} />
    <Route path="vendor-profile" onEnter={isLoggedIn} component={VendorProfileContainer(VendorProfile)} />
    <Route
      path="vendor-profile/manage-profile"
      onEnter={isLoggedIn}
      component={VendorProfileContainer(ProfileCreation)}
    />
    <Route path="overview" onEnter={isLoggedIn} component={AuthContainer(Overview)} />
    <Route path="open-jobs" onEnter={isLoggedIn} component={AuthContainer(OpenJobs)} />
    <Route path="User-Accounts" onEnter={isLoggedIn} component={UseraccountContainer(UserAccounts)} />
    <Route path="results" onEnter={isLoggedIn} component={AuthContainer(Results)} />
    <Route path="inbox" onEnter={isLoggedIn} component={AuthContainer(Inbox)} />
    <Route path="emergency-list" onEnter={isLoggedIn} component={AuthContainer(EmergencyList)} />
    {/* <Route path="open-jobs/:type" onEnter={isLoggedIn} component={JobRequestContainer(StatusList)} /> */}
    <Route path="open-jobs/waiting" onEnter={isLoggedIn} component={JobRequestContainer(WaitingJobs)} />
    <Route path="open-jobs/applied" onEnter={isLoggedIn} component={JobRequestContainer(AppliedJobs)} />
    <Route path="open-jobs/confirmed" onEnter={isLoggedIn} component={JobRequestContainer(ConfirmedJobs)} />
    <Route path="open-jobs/progress" onEnter={isLoggedIn} component={JobRequestContainer(InprogressJobs)} />
    <Route path="open-jobs/completed" onEnter={isLoggedIn} component={JobRequestContainer(CompletedJobs)} />
    <Route path="job/:job_id" onEnter={isLoggedIn} component={JobRequestContainer(JobDetailsView)} />
    <Route path="job-history" onEnter={isLoggedIn} component={JobRequestContainer(JobHistory)} />
    <Route path="empty-state" onEnter={scrollToTop} component={AuthContainer(EmptyState)} />
    <Route path="manage-Users" onEnter={scrollToTop} component={ManageInfoContainer(ManageUser)} />
    <Route path="my-Vehicles" onEnter={scrollToTop} component={ManageInfoContainer(MyVehicles)} />
    <Route path="add-Users" onEnter={scrollToTop} component={ManageInfoContainer(AddUser)} />
    <Route path="add-Vehicle" onEnter={scrollToTop} component={ManageInfoContainer(AddVehicle)} />
    <Route path="edit-user-info/:id" onEnter={scrollToTop} component={ManageInfoContainer(EditUser)} />
    <Route
      path="vendor-profile/manage-services"
      onEnter={isLoggedIn}
      component={VendorProfileContainer(ManageServices)}
    />
    <Route path="edit-vehicle/:id" onEnter={scrollToTop} component={ManageInfoContainer(EditVehicle)} />
    <Route
      path="vehicle-personal-info/:id"
      onEnter={scrollToTop}
      component={ManageInfoContainer(VehiclePersonalInfo)}
    />
    <Route path="terms" onEnter={scrollToTop} component={ManageInfoContainer(TermsAndConditions)} />
    <Route path="onboarding" onEnter={scrollToTop} component={ManageInfoContainer(Onboarding)} />
    <Route path="driver-dashboard" onEnter={isLoggedIn} component={DriverEmergenyContainer(DriverEmergencyHome)} />
    <Route
      path="driver-AcceptDecline/:id"
      onEnter={isLoggedIn}
      component={DriverEmergenyContainer(DriverEmergencyAceptDecline)}
    />
    <Route
      path="driver-CompleteJob/:id"
      onEnter={isLoggedIn}
      component={DriverEmergenyContainer(DriverEmergencyEndJob)}
    />
    <Route path="review-rating" onEnter={isLoggedIn} component={VendorProfileContainer(ReviewRating)} />
    <Route path="faq" component={AuthContainer(Faq)} />
    <Route
      path="privacy"
      onEnter={scrollToTop}
      component={AuthContainer(Policy)}
    />
    <Route path="contact-business" component={AuthContainer(ContactUs)} />
    <Route path="notification" onEnter={isLoggedIn} component={AuthContainer(Notification)} />
    <Route path="*" onEnter={scrollToTop} component={pageNotFound} />
  </Route>
);



// WEBPACK FOOTER //
// ./src/routes.js